import { gql } from '@apollo/client';

export * from './createCustomIntegration.mutation.generated';

export const CREATE_CUSTOM_INTEGRATION = gql`
  mutation createCustomIntegration($customIntegrationInput: CustomIntegrationInputAttributes!) {
    createCustomIntegration(input: { customIntegrationInput: $customIntegrationInput }) {
      success
      errors
      customIntegration {
        provider
        id
      }
    }
  }
`;
